import React from 'react';

import HeaderButtonsStyling from './headerButton.scss';

import { checkForIos, checkForIpad } from '../../../utils/checkForIos';

var once = true;

class headerButtons extends React.PureComponent {
	constructor(props) {
		super(props);
		once = false;

		// this.onHiddenReverse = this.onHiddenReverse.bind(this);
	}

	componentDidMount() {
		// once = false;
	}

	// onHiddenReverse() {
	// 	console.log('hh');
	// 	document.getElementById('app').style.overflow = 'visible';
	// }

	render() {
		let { dropOpen, className = '' } = this.props;
		if (dropOpen) {
			document.getElementById('app').style.overflow = ' hidden';
		}
		else {
			document.getElementById('app').style.overflow = 'visible';
		}
		let blueBtn = '';
		let ipadClass;

		if (checkForIpad()) {
			if (dropOpen)
				ipadClass = [
					HeaderButtonsStyling.iconsForIpad,
					HeaderButtonsStyling.dropOpenIpad,
					className === 'search' ? HeaderButtonsStyling.searchWrapForIpad : ''
				].join(' ');
			else if (
				!dropOpen &&
				window.location.hash === '#/' &&
				(document.getElementById('app').scrollTop > 0 ||
					(document.getElementById('main-home-wrapper') &&
						document.getElementById('main-home-wrapper').scrollTop > 0))
			)
				ipadClass = [
					HeaderButtonsStyling.iconsForIpadClose,
					'blue-button'
				].join(' ');
			else if (!dropOpen && window.location.hash !== '#/')
				ipadClass = [
					HeaderButtonsStyling.iconsForIpadClose,
					'blue-button'
				].join(' ');
			else
				ipadClass = [
					HeaderButtonsStyling.iconsForIpadClose
				].join(' ');
		}
		if (
			document.getElementById('app').scrollTop <= 0 &&
			(window.location.hash === '#/getintouch' || window.location.hash === '#/collabs')
		) {
			blueBtn = 'blue-button';
		}
		else if (!dropOpen && document.getElementById('app').scrollTop <= 0) {
			blueBtn = '';
		}
		else if (dropOpen) {
			blueBtn = '';
		}
		else if (!dropOpen && window.location.hash === '#/' && document.getElementById('app').scrollTop <= 0) {
			blueBtn = '';
		}
		else {
			blueBtn = 'blue-button';
		}

		return (
			<div
				className={
					checkForIpad() ? (
						ipadClass
					) : dropOpen ? (
						`${HeaderButtonsStyling.dropOpen} ${HeaderButtonsStyling.dropOpenMobile} ${HeaderButtonsStyling.icons} ${className ===
						'search'
							? HeaderButtonsStyling.searchWrap
							: ''} blueBtn`
					) : once ? (
						[
							HeaderButtonsStyling.icons,
							blueBtn
						].join(' ')
					) : (
						[
							HeaderButtonsStyling.icons,
							HeaderButtonsStyling.dropClose,
							blueBtn
						].join(' ')
					)
				}
				id="header-drop-open"
			>
				<div />
				<div />
				<div />
			</div>
		);
	}
}

export default headerButtons;



// WEBPACK FOOTER //
// ./components/header/components/headerButton.js